export const OfficePricingState = {
	url: '/economic-profile',
	title: 'Office Pricing',
	template: '<pricing-engine></pricing-engine>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officePricingPageMod" */
			'@Containers/office-pricing-engine/office-pricing-engine.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
